import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_ANNOUNCEMENTS_ACTION_TYPE } from '../actions/announcements.actions';

const initialState = null;

const announcementsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_ANNOUNCEMENTS_ACTION_TYPE.SET_ANNOUNCEMENTS:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default announcementsReducer;
